module.exports = Jsw.skinUrl + "/icons/16/plesk/file-binary.png?e5e874cc42fb4473aab65dcace6e6664";